import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ResidualScale } from '~/containers/viewer/explorer-sidebar/WorkflowSidebar/AdaptiveReplanningStep/useRunLandmarkResiduals';
import { formatMmAsCmAtScale } from '~/utils/units';

export default function ResidualScaleNote({
    scale,
    testIdPrefix,
}: {
    scale: ResidualScale;
    testIdPrefix: string;
}) {
    const line = (id: string, valueMm: number | undefined, suffix: string) =>
        valueMm === undefined ? null : (
            <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: 'block', fontSize: 10 }}
                data-testid={`${testIdPrefix}-${suffix}`}
            >
                <FormattedMessage
                    id={id}
                    values={{ value: formatMmAsCmAtScale(valueMm, 'voxel') }}
                />
            </Typography>
        );

    return (
        <>
            {line('landmark.scale.voxel', scale.voxelMm, 'voxel-scale')}
            {line('landmark.scale.grid', scale.gridMm, 'grid-scale')}
        </>
    );
}
